import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function getAllproveedores(producto) {
    const ProveedoresBD =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Proveedores/");
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      ProveedoresBD.push(doc.data());
    });
    return ProveedoresBD;
    
}
